import { Building2, Wrench, Factory, Users } from 'lucide-react'

const partners = [
  {
    name: 'Indústrias Metalúrgicas',
    icon: Factory,
    desc: 'Fornecimento contínuo de matéria-prima.',
  },
  {
    name: 'Oficinas Mecânicas',
    icon: Wrench,
    desc: 'Coleta regular de peças e componentes.',
  },
  {
    name: 'Construtoras',
    icon: Building2,
    desc: 'Remoção de resíduos de obras e demolições.',
  },
  {
    name: 'Cooperativas',
    icon: Users,
    desc: 'Parceria para triagem e valorização.',
  },
]

export const PartnersSection = () => {
  return (
    <div className="h-full flex flex-col animate-fade-in p-4">
      <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6 border-b-2 border-gray-400 pb-2">
        Parceiros e Indústrias
      </h2>

      <div className="space-y-4">
        {partners.map((partner, index) => (
          <div
            key={index}
            className="retro-bevel-outset bg-white p-4 flex items-center gap-4 hover:bg-blue-50 transition-colors"
          >
            <div className="w-12 h-12 bg-gray-200 retro-bevel-inset flex items-center justify-center shrink-0">
              <partner.icon className="w-8 h-8 text-gray-700" />
            </div>
            <div>
              <h3 className="font-serif font-bold text-xl text-blue-900">
                {partner.name}
              </h3>
              <p className="font-mono text-sm text-gray-600">{partner.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 p-4 bg-yellow-100 border border-yellow-400 text-center font-serif">
        <p>
          Quer ser nosso parceiro? Entre em contato e conheça nossas condições
          especiais.
        </p>
      </div>
    </div>
  )
}
